module.exports = __webpack_public_path__ + "static/img/windows_FAQ_pic07.752f443.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/windows_FAQ/windows_FAQ_pic07.png
// module id = 604
// module chunks = 1